module.exports = __webpack_public_path__ + "img/2f_r_kasuya@2x.eda0d046.png";